module.exports = __webpack_public_path__ + "img/img30.6e02df77.png";